import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	getAuditTrailReportExcelFailure,
	getAuditTrailReportExcelResponseChanged,
	getAuditTrailReportExcelSuccess,
	getAuditTrailReportFailure,
	getAuditTrailReportJsonFailure,
	getAuditTrailReportJsonResponseChanged,
	getAuditTrailReportJsonSuccess,
	getAuditTrailReportResponseChanged,
	getAuditTrailReportSuccess,
} from './audit-trail-report.action';
import AuditTrailReportActionTypes from './audit-trail-report.type';
import {
	auditTrailReportExcelget,
	auditTrailReportGet,
	auditTrailReportJSONGet,
} from './audit-trail-report.service';

/******************* GET AUDIT TRAIL REPORT START *****************/
export function* getAuditTrailReportList({ payload }: any) {
	try {
		const key = 'AuditTrailReportKey';
		const jsonData = {
			CompanyID: payload.companyID,
			BranchID: payload.branchID,
			DatabaseName: payload.databaseName,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
			SearchLog: payload.filterData,
			ReportMode: payload.ReportMode,
			Limit: payload.limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(auditTrailReportGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAuditTrailReportFailure(responseData.data));
		} else {
			yield put(getAuditTrailReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAuditTrailReportFailure(error));
	}
}

export function* resetgetAuditTrailReportListResponse() {
	yield put(getAuditTrailReportResponseChanged());
}

export function* ongetAuditTrailReportListDetails() {
	yield takeLatest(
		AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_START,
		getAuditTrailReportList,
	);
}

export function* ongetAuditTrailReportListResponseReset() {
	yield takeLatest(
		AuditTrailReportActionTypes.GET_AUDIT_TRAIL_REPORT_LIST_RESPONSE_RESET,
		resetgetAuditTrailReportListResponse,
	);
}
/******************* GET AUDIT TRAIL REPORT ENd *****************/

/** ***************** AUDIT TRAIL REPORT REPORT EXCEL START *********************** */
export function* getAuditTrailReportExcel({ payload }: any) {
	try {
		const key = 'AuditTrailReportExcelKey';
		const jsonData = {
			CompanyID: payload.CompanyID,
			DatabaseName: payload.DatabaseName,
			FromDate: payload.FromDate,
			ToDate: payload.ToDate,
			BranchID: payload.BranchID,
			SearchLog: payload.filterData,
			CountLimit: payload.Limit,
			UserID: payload.UserID,
			ReportMode: payload.ReportMode,
			RequestID: payload.RequestID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(auditTrailReportExcelget, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '500') {
			yield put(getAuditTrailReportExcelFailure(responseData.data));
		} else {
			yield put(getAuditTrailReportExcelSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAuditTrailReportExcelFailure(error));
	}
}
export function* resetgetAuditTrailExcelListResponse() {
	yield put(getAuditTrailReportExcelResponseChanged());
}

export function* ongetAuditTrailReportExcelListDetails() {
	yield takeLatest(
		AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_START,
		getAuditTrailReportExcel,
	);
}

export function* ongetAuditTrailReportExcelListResponseReset() {
	yield takeLatest(
		AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_EXCEL_RESET,
		resetgetAuditTrailExcelListResponse,
	);
}
/** ***************** AUDIT TRAIL REPORT REPORT EXCEL START *********************** */

/** ***************** FETCH POST AUDIT TRAIL REPORT JSON START *********************** */
export function* getAuditTrailReportJSON({ payload }: any) {
	try {
		const key = 'AuditTrailReportJsonKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			PaySprintLogID: payload.paySprintLogID,
			Type: payload.type,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
			BranchID: payload.branchID,
			SearchLog: payload.filterData,
			// CountLimit: payload.Limit,
			// UserID: payload.UserID,
			ReportMode: payload.reportMode,
			// RequestID: payload.RequestID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(auditTrailReportJSONGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '500') {
			yield put(getAuditTrailReportJsonFailure(responseData.data));
		} else {
			yield put(getAuditTrailReportJsonSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAuditTrailReportJsonFailure(error));
	}
}
export function* resetgetAuditTrailJSONListResponse() {
	yield put(getAuditTrailReportJsonResponseChanged());
}

export function* ongetAuditTrailReportJSONListDetails() {
	yield takeLatest(
		AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_START,
		getAuditTrailReportJSON,
	);
}

export function* ongetAuditTrailReportJSONListResponseReset() {
	yield takeLatest(
		AuditTrailReportActionTypes.FETCH_POST_AUDIT_TRAIL_REPORT_JSON_RESET,
		resetgetAuditTrailJSONListResponse,
	);
}
/** ***************** FETCH POST AUDIT TRAIL REPORT JSON END *********************** */

export function* auditTrailReportSaga() {
	yield all([
		call(ongetAuditTrailReportListDetails),
		call(ongetAuditTrailReportListResponseReset),
		call(ongetAuditTrailReportExcelListDetails),
		call(ongetAuditTrailReportExcelListResponseReset),
		call(ongetAuditTrailReportJSONListDetails),
		call(ongetAuditTrailReportJSONListResponseReset),
	]);
}
